import { Component, input } from '@angular/core';
import { RouterLink } from '@angular/router';
import { LogoComponent } from '@core/ui';
import { TrackLinkDirective } from '@analytics/events';

@Component({
  selector: 'wl-navigation-logo',
  standalone: true,
  imports: [RouterLink, LogoComponent, TrackLinkDirective],
  templateUrl: './navigation-logo.component.html',
  styleUrls: [
    './navigation-logo.component.ed.scss',
    './navigation-logo.component.essent.scss',
  ],
})
export class NavigationLogoComponent {
  /** The logo variant */
  readonly variant = input<'dark' | 'light'>('dark');

  /** The aria-label on the <a> tag */
  readonly label = input.required<string>();

  /** The url to navigate to when the logo is clicked */
  readonly url = input.required<string>();

  /** The width of the logo in pixels (leave empty to use the default width) */
  readonly width = input<number>();

  /** The height of the logo in pixels (leave empty to use the default height) */
  readonly height = input<number>();
}
